<template>
    <DashboardLayout>
        <Breadcrumb class="flex breadcrumb" :model="items" />
        <div class="card flex flex-column justify-center pt-4 px-4">
            <div class="flex align-item-center justify-content-center h-full">
                <div class="flex flex-column ">
                    <span class="Caption text-gray-700 text-center"> Coming Soon</span>
                </div>
            </div>
        </div>
    </DashboardLayout>
</template>

<script setup>
import { ref } from "vue";
import Breadcrumb from 'primevue/breadcrumb';
import DashboardLayout from "@/layout/DashboardLayout.vue";
const items = ref([
    { label: 'Dashboard' },
    { label: 'Home Work' },
]);
</script>
<style scoped>
.breadcrumb {
    display: flex !important;
    flex-wrap: wrap !important;
    overflow-x: hidden !important;
}

.text-gray-700 {
    color: var(--gray-700) !important;
    padding-top: 30vh;
}

@media (max-width: 767px) {
    .breadcrumb {
        font-size: 12px;

    }
}
</style>